import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
    selector: 'ngx-confirm-modal',
    templateUrl: 'confirm-modal.component.html',
    styleUrls: ['confirm-modal.component.scss'],
    standalone: false
})
export class ConfirmModalComponent {

  @Input() title: string;
  @Input() message: string;

  constructor(protected ref: NbDialogRef<ConfirmModalComponent>) {}

  cancel() {
    this.ref.close();
  }

  ok() {
    this.ref.close(true);
  }
}
